export class WorkOrder {
  lsSaleLineId: string;
  lsWorkOrderId: string;
  workOrderType: string;
  workOrderNote: string;

  constructor(saleLine: SaleLine) {
    this.lsSaleLineId = `${saleLine.saleLineID}` || '';
    this.lsWorkOrderId = `${saleLine.SaleLineWorkOrder?.workOrderId}` || '';
    this.workOrderType = `${saleLine.SaleLineWorkOrder?.workOrderType}` || '';
    this.workOrderNote = `${saleLine.Note?.note}` || '';
  }
}
